import React from 'react'

import { isInternal } from './util/index'
import { Text } from './core'

export const Link = React.forwardRef(
  ({ href, getProps, children, ...props }, ref) => {
    let linkUrl = href

    if (typeof linkUrl === 'string' && linkUrl.match(/^https?:\/\/#/))
      linkUrl = linkUrl.replace(/^https?:\/\//, '')

    return (
      <Text
        as="a"
        ref={ref}
        href={linkUrl}
        getProps={getProps}
        display="inline"
        rel={!isInternal(linkUrl) && 'nofollow noopener noreferrer'}
        {...props}
      >
        {children}
      </Text>
    )
  },
)
